// extracted by mini-css-extract-plugin
export default {"root":"fHLWg","text":"BUH7V"};